// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I3ZqtfJciuctGR7vHRCz {
  background-color: white;
  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  margin: -70px auto;
  width: 100%;
}

.qRuQCSXO4rCa_LKmU4AX {
  margin: 50px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.ELTWtphmzWIWdCOmTU_g,
.LC0LOgBK9rhyMZmOvmcD {
  margin-right: 10%;
}

.qRuQCSXO4rCa_LKmU4AX .VPO2H5Dr_cGOTtovK9cw {
  width: 30%;
}

.qRuQCSXO4rCa_LKmU4AX .AY_x2ZB2rhao_iyrf_0A {
  width: 68%;
  display: flex;
  flex-direction: column;
}

.qRuQCSXO4rCa_LKmU4AX .AY_x2ZB2rhao_iyrf_0A p {
  margin-top: 0
}

.kRt4gXshQYDrMxriXam5 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.e3xRHGosFBGiJlPFoMj3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.e3xRHGosFBGiJlPFoMj3 > div {
  width: 100%;
  margin-top: 11px;
}

.aY_VkNV91cVL6phAmPUe > div {
  grid-template-columns: repeat(2, 50%);
}

.aY_VkNV91cVL6phAmPUe > div > div {
  flex-direction: row;
  height: 50px;
  text-align: left;
  justify-content: left;
  padding-left: 10px;
  align-items: unset;
}

.I3ZqtfJciuctGR7vHRCz > .qRuQCSXO4rCa_LKmU4AX input,
.I3ZqtfJciuctGR7vHRCz > .qRuQCSXO4rCa_LKmU4AX .YJEJ6tz0aIqIXdt4mvei {
  height: 50px;
}

.I3ZqtfJciuctGR7vHRCz *,
.I3ZqtfJciuctGR7vHRCz p,
.I3ZqtfJciuctGR7vHRCz label {
  font-size: 20px;
}

.doImtE9MStSfgsXEbaW8 {
  grid-column: 2;
  justify-self: end;
  height: 50px;
  flex-direction: row-reverse;
}

.doImtE9MStSfgsXEbaW8 span {
  margin-left: 8px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .qRuQCSXO4rCa_LKmU4AX {
    margin: 10px;
    display: flex;
    flex-direction: column;
  }

  .ELTWtphmzWIWdCOmTU_g {
    margin-bottom: 20px;
  }

  .ELTWtphmzWIWdCOmTU_g,
  .LC0LOgBK9rhyMZmOvmcD {
    margin-right: 0;
  }

  .aY_VkNV91cVL6phAmPUe > div {
    grid-template-columns: repeat(1, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Simulation/Simulation.module.css"],"names":[],"mappings":"AAMA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;AACvC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-light-dark, color-purple from colors;\n\n.simulation {\n  background-color: white;\n  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  margin: -70px auto;\n  width: 100%;\n}\n\n.content {\n  margin: 50px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.containerAmountSought,\n.containerTypeInvestment {\n  margin-right: 10%;\n}\n\n.content .countryCompany {\n  width: 30%;\n}\n\n.content .sirenCompany {\n  width: 68%;\n  display: flex;\n  flex-direction: column;\n}\n\n.content .sirenCompany p {\n  margin-top: 0\n}\n\n.containerCompany {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.containerCA {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.containerCA > div {\n  width: 100%;\n  margin-top: 11px;\n}\n\n.choiceButton > div {\n  grid-template-columns: repeat(2, 50%);\n}\n\n.choiceButton > div > div {\n  flex-direction: row;\n  height: 50px;\n  text-align: left;\n  justify-content: left;\n  padding-left: 10px;\n  align-items: unset;\n}\n\n.simulation > .content input,\n.simulation > .content .input {\n  height: 50px;\n}\n\n.simulation *,\n.simulation p,\n.simulation label {\n  font-size: 20px;\n}\n\n.submitButton {\n  grid-column: 2;\n  justify-self: end;\n  height: 50px;\n  flex-direction: row-reverse;\n}\n\n.submitButton span {\n  margin-left: 8px;\n}\n\n@media screen and (max-width: tablet-l) {\n  .content {\n    margin: 10px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .containerAmountSought {\n    margin-bottom: 20px;\n  }\n\n  .containerAmountSought,\n  .containerTypeInvestment {\n    margin-right: 0;\n  }\n\n  .choiceButton > div {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-light-dark": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-light-dark"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"simulation": `I3ZqtfJciuctGR7vHRCz`,
	"content": `qRuQCSXO4rCa_LKmU4AX`,
	"containerAmountSought": `ELTWtphmzWIWdCOmTU_g`,
	"containerTypeInvestment": `LC0LOgBK9rhyMZmOvmcD`,
	"countryCompany": `VPO2H5Dr_cGOTtovK9cw`,
	"sirenCompany": `AY_x2ZB2rhao_iyrf_0A`,
	"containerCompany": `kRt4gXshQYDrMxriXam5`,
	"containerCA": `e3xRHGosFBGiJlPFoMj3`,
	"choiceButton": `aY_VkNV91cVL6phAmPUe`,
	"input": `YJEJ6tz0aIqIXdt4mvei`,
	"submitButton": `doImtE9MStSfgsXEbaW8`
};
export default ___CSS_LOADER_EXPORT___;
